module.exports = __webpack_public_path__ + "img/Steor-Icons-05.e3891a50.svg";